module.exports = __webpack_public_path__ + "static/img/akum_600_55.8f3016c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_600_55.svg
// module id = nts8
// module chunks = 1